import apiExcel from '@/api/excel'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  excelUserReportsStart: '[excel] excel user reports start',
  excelUserReportsSuccess: '[excel] excel user reports success',
  excelUserReportsFailure: '[excel] excel user reports failure'
}

export const actionTypes = {
  excelUserReports: '[excel] user reports excel'
}

const mutations = {
  [mutationTypes.excelUserReportsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.excelUserReportsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.excelUserReportsFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.excelUserReports](context, {id}) {
    context.commit(mutationTypes.excelUserReportsStart)
    return new Promise(resolve => {
      apiExcel
        .userReports(id)
        .then(response => {
          context.commit(mutationTypes.excelUserReportsSuccess)
          const file = new Blob([response.data], {
            type: response.headers['content-type']
          })

          const link = URL.createObjectURL(file)
          resolve(link)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.excelUserReportsFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
